import { compose, createStore, applyMiddleware  } from 'redux';
import createHistory from 'history/createBrowserHistory';
import { reactReduxFirebase } from 'react-redux-firebase';
import firebase from '@firebase/app';
import '@firebase/auth';
import '@firebase/database';
import { routerMiddleware } from 'react-router-redux';

import { makeRootReducer } from './reducers';
import { fbConfig, reduxfbConfig } from './config/firebase';

// Initialize Firebase
firebase.initializeApp(fbConfig);

// Create a history of your choosing (we're using a browser history in this case)
const history = createHistory();

// Build the middleware for intercepting and dispatching navigation actions
const routeMiddleware = routerMiddleware(history);

// Initial state.
// const initialState = {};

// Create enhancers.
const enhancers = [];
if (process.env.NODE_ENV === 'development') {
  const devToolsExtension = window.devToolsExtension
  if (typeof devToolsExtension === 'function') {
    enhancers.push(devToolsExtension())
  }
}

const store = createStore(
  makeRootReducer(),
  compose (
    applyMiddleware(routeMiddleware),
    reactReduxFirebase(firebase, reduxfbConfig),
    ...enhancers
  )
);

export { history, store };


// WEBPACK FOOTER //
// ./src/store.js